export class VacationRequestInput {
  id: number
  fromDate: Date
  toDate: Date
  leaveTypeId: number
  description: string
  vacationUserId: number
  selectedVacationDays: number
}
